module.exports = __webpack_public_path__ + "static/05-16bdb84db61b5f3d649b42bb1942f062.jpg";